<template>
  <div class="c-heroblock">
    <div v-if="this.background && this.background.IsVideo" class="c-heroblock-video">
      <div v-html="this.background.Content"></div>
      <div class="c-heroblock-overlay"></div>
    </div>
    <div v-else class="c-heroblock-media">
      <picture>
        <img alt="Background Image" class="c-heroblock-picture" loading="lazy" :src="this.background.Content" />
      </picture>
      <div class="c-heroblock-overlay"></div>
    </div>
    <div :class="computedClassList" :style="containsText">
      <h2 :style="setColor" class="c-heroblock-text__title">{{ heading }}</h2>
      <p :style="setColor">{{ preamble }}</p>
      <a v-if="buttonLink" :style="setColorButton" :class="additionalClasses" :href="buttonLink" class="c-heroblock-text__button">{{ buttonText }}</a>
    </div>
  </div>
</template>
<script>
export default {
  name: "VHeroBlock",
  props: {
    heading: String,
    placement: String,
    preamble: String,
    buttonText: String,
    buttonLink: String,
    background: String,
    boxcolor: String,
    classList: String,
  },
  computed: {
    heroBlockTextStyle() {
      return {
        backgroundColor: this.boxcolor.BackgroundColor,
        color: this.boxcolor.Color,
      };
    },
    containsText() {
      if(this.classList && this.classList.includes("c-hidebox")) {
        return null;
      }
      return this.heroBlockTextStyle;
    },
    setColor() {
      if(this.classList && this.classList.includes("c-hidebox")) {
        return null;
      }
      return {
        color: this.boxcolor.Color,
      }
    },
    setColorButton() {
      if(this.classList && this.classList.includes("c-hidebox")) {
        return null;
      }
      return {
        color: this.boxcolor.Color,
        border: `1px solid ${this.boxcolor.Color}`
      }
    },
    alignmentClass() {
      switch (this.placement) {
        case 'left':
          return 'left';
        case 'center':
          return 'center';
        case 'right':
          return 'right';
        default:
          return 'center';
      }
    },
    computedClassList() {
      return `${this.classList} ${this.alignmentClass}`;
    },
    additionalClasses() {
      return `${this.boxcolor.CssColorClass}`;
    },
  },
};
</script>